import { Navigate } from 'react-router-dom';
import { useDealer } from '../../context/DealerContext';
import DealerStatePage from '../../components/dealer/DealerStatePage';
import type { DealerAuth } from './types';

/** `/dealer/blocked` — a suspended or inactive dealer, or a disabled membership (BR-5). */
export default function DealerBlockedPage({ auth }: { auth: DealerAuth }) {
  const { state, blockedCode } = useDealer();
  if (state === 'loading') {
    return <div className="loading-container"><div className="loading-spinner"></div></div>;
  }
  if (state !== 'blocked') {
    return <Navigate to="/dealer/dashboard" replace />;
  }
  return (
    <div className="dealer-blocked-page">
      <DealerStatePage reason="blocked" code={blockedCode} onLogout={auth.logout} />
    </div>
  );
}
